import { z } from 'zod';

export const SortingMethod_S = z.object({
    key: z.string(),
    name: z.string(),
    order: z.number(),
    type: z.union([z.literal('asc'), z.literal('desc')]),
});

export const SortingMethods_S = z.array(SortingMethod_S);

export const SelectedSort_S = z
    .object({
        order: z.union([z.literal('asc'), z.literal('desc')]),
        field: z.string(), // TODO: correct variable name in SRD-502, why is it called field and not key like in the setup coming from configuration ?
    })
    .nullable();
